import { FileSaver } from 'file-saver'
import jsPDF from 'jspdf'
import domtoimage from '../assets/js/vendor/domtoimage'
import { isSafari } from 'mobile-device-detect'
import html2canvas from 'html2canvas'

export default {

  methods: {
    /**
     * action download for desktop
     */
    handleDownloadDesktop (ID, TYPE) {
      let self = this

      if (isSafari) {
        this.downloadForSafari(ID, TYPE)
      } else {
        domtoimage.toJpeg(ID, {
          style: self.styleForExport
        }).then(dataUrl => {
          let imgStr = dataUrl.replace('data:image/jpeg;base64,', '')

          let blobImg = self.b64toBlob(imgStr, 'image/jpeg')
          const blobUrl = URL.createObjectURL(blobImg)

          return TYPE === 'image' ? self.downloadImageDesktop(blobUrl) : self.downloadPdfOnDesktop(blobUrl)
        }).then(() => self.loading = false).catch(() => self.loading = false)
      }
    },

    /**
     * action download for mobile
     */
    handleDownloadMobile (TYPE) {
      // Call action when Dom is rendered
      if (TYPE === 'image') {
        // Download Image
        this.downloadImageMobile(this.output)
      } else {
        // Download Video
        this.downloadPdfOnMobile(this.output)
      }
    },

    /**
     * action download PDF
     * @param base64URL
     * @returns {jsPDF}
     */
    async downloadPdfOnMobile (base64URL) {
      let imgStr = base64URL.replace('data:image/jpeg;base64,', '')
      let blob = this.b64toBlob(imgStr, 'image/jpeg')
      blob.name = this.fileDownloadName

      const image = new Image()
      image.src = URL.createObjectURL(blob)
      image.crossOrigin = 'Anonymous'

      const pdf = new jsPDF()
      pdf.addImage(image, 'JPEG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight(), '',
        'FAST')
      let newBlob = pdf.output('blob')
      newBlob.name = this.fileDownloadName + '.pdf'

      this.loading = false
      saveAs(newBlob, this.fileDownloadName + '.pdf')
    },

    /**
     * action download PDF
     * @param blobUrl
     * @returns {jsPDF}
     */
    downloadPdfOnDesktop (blobUrl) {
      const image = new Image()
      image.src = blobUrl
      image.crossOrigin = 'Anonymous'

      const pdf = new jsPDF()
      pdf.addImage(image, 'JPEG', 0, 0, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight())

      return pdf.save(`${ this.fileDownloadName }.pdf`)
    },

    /**
     * Download Image for Mobile
     */
    downloadImageMobile (base64URL) {
      // Download Image
      this.item.svg = base64URL
      this.item.$save()
      this.$router.push({ name: 'ExportImage' })
    },

    /**
     * Download Image for Desktop
     * @param blobUrl
     */
    downloadImageDesktop (blobUrl) {
      let link = document.createElement('a')

      link.download = this.fileDownloadName + '.jpeg'
      link.href = blobUrl
      return link.click()
    },

    /**
     * Convert Base64 to Blob
     */
    b64toBlob (b64Data, contentType = '', sliceSize = 512) {
      const byteCharacters = atob(b64Data)
      const byteArrays = []

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)

        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }

      return new Blob(byteArrays, { type: contentType })
    },

    /**
     * Download For Safari Browser
     * @param ID
     */
    downloadForSafari (ID, TYPE) {
      let self = this

      //Get preview position to render image
      let YPos = ID.offsetTop
      let xPos = ID.offsetLeft

      let startRender = new Date().getTime()
      this.$nextTick(() => {
        // set main title position
        this.handleMainTitlePosition()
        // set Logo
        this.handleLogoPosition()
        // set Sub Headline
        this.handleSubHeadline()

        html2canvas(ID, {
          // logging: true,
          imageTimeout: 0,
          allowTaint: true,
          x: xPos,
          y: YPos,
          scrollX: 0,
          scrollY: 0,
          scale: 3
        }).then(canvas => {
          let imgStr = canvas.toDataURL('image/jpeg').replace('data:image/jpeg;base64,', '')

          let blobImg = self.b64toBlob(imgStr, 'image/jpeg')
          const blobUrl = URL.createObjectURL(blobImg)

          return TYPE === 'image' ? self.downloadImageDesktop(blobUrl) : self.downloadPdfOnDesktop(blobUrl)
        }).then(() => {
          self.loading = false

          let endRender = new Date().getTime()
          console.log('Execution time: ' + (endRender - startRender))
        }).catch(() => self.loading = false)
      })
    }
  }
}